var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBudget(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.577 22.3687H7.753C4.312 22.3687 2 19.9537 2 16.3597V8.04571C2 4.45171 4.312 2.03671 7.753 2.03671H11.492C11.906 2.03671 12.242 2.37271 12.242 2.78671C12.242 3.20071 11.906 3.53671 11.492 3.53671H7.753C5.169 3.53671 3.5 5.30671 3.5 8.04571V16.3597C3.5 19.0987 5.169 20.8687 7.753 20.8687H16.577C19.161 20.8687 20.831 19.0987 20.831 16.3597V12.3317C20.831 11.9177 21.167 11.5817 21.581 11.5817C21.995 11.5817 22.331 11.9177 22.331 12.3317V16.3597C22.331 19.9537 20.018 22.3687 16.577 22.3687Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.86762 15.4283H11.8446C12.2246 15.4283 12.5806 15.2813 12.8496 15.0123L20.3586 7.50331C20.6666 7.19531 20.8366 6.78531 20.8366 6.34931C20.8366 5.91231 20.6666 5.50131 20.3586 5.19331L19.1416 3.97631C18.5046 3.34131 17.4686 3.34131 16.8306 3.97631L9.35762 11.4493C9.09862 11.7083 8.95162 12.0523 8.94262 12.4173L8.86762 15.4283ZM11.8446 16.9283H8.09862C7.89662 16.9283 7.70262 16.8463 7.56162 16.7013C7.42062 16.5573 7.34362 16.3623 7.34862 16.1593L7.44262 12.3803C7.46162 11.6283 7.76462 10.9213 8.29662 10.3883H8.29762L15.7706 2.91531C16.9926 1.69531 18.9796 1.69531 20.2016 2.91531L21.4186 4.13231C22.0116 4.72431 22.3376 5.51131 22.3366 6.34931C22.3366 7.1873 22.0106 7.97331 21.4186 8.56431L13.9096 16.0733C13.3586 16.6243 12.6246 16.9283 11.8446 16.9283Z",
    fill: "current"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.7308 9.9166C19.5388 9.9166 19.3468 9.8436 19.2008 9.6966L14.6348 5.1306C14.3418 4.8376 14.3418 4.3626 14.6348 4.0696C14.9278 3.7766 15.4018 3.7766 15.6948 4.0696L20.2608 8.6366C20.5538 8.9296 20.5538 9.4036 20.2608 9.6966C20.1148 9.8436 19.9228 9.9166 19.7308 9.9166Z",
    fill: "current"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBudget);
export default __webpack_public_path__ + "static/media/Budget.5fe823c76d9370bce3bd333b24d589c3.svg";
export { ForwardRef as ReactComponent };